import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Grid,
    TextField,
    MenuItem,
    FormControlLabel,
    Switch,
} from "@mui/material";

import { put } from "src/services/httpClient.service";
import { authenticationService } from "src/services";
import { useSnackbar } from "src/components/snackbar/useSnackbar";

interface Props {
    open: boolean;
    onClose: () => void;
    data: any;
}

const UpdateApplicationServer = ({
    open,
    onClose,
    data,
}: Props) => {
    const { showSnackbar } = useSnackbar();
    const API_URL = process.env.REACT_APP_BASE_API_URL;
    const [updateLoading, setUpdateLoading] = useState(false);
    const { vendorId } = authenticationService.getVendorFranchiseIds();

    const TYPE_OPTIONS = [
        { label: 'DRM', value: 'DRM' },
        { label: 'CRM', value: 'CRM' },
        { label: 'Others', value: 'OTHER' },
    ];

    const [formData, setFormData] = useState({
        id: "",
        name: "",
        url: "",
        serverType: "",
        serverRole: "MAIN",
        isActive: true,
        priority: 1,
        serverUserName: "",
        serverPassword: "",
        vendorId,
    });

    useEffect(() => {
        if (data) {
            setFormData({
                id: data.id,
                name: data.name || "",
                url: data.url || "",
                serverType: data.serverType || "",
                serverRole: data.serverRole || "MAIN",
                isActive: data.isActive,
                priority: data.priority,
                serverUserName: data.serverUserName || "",
                serverPassword: data.serverPassword || "",
                vendorId,
            });
        }
    }, [data, vendorId]);

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]:
                name === "priority" ||
                    name === "failureCount"
                    ? Number(value)
                    : value,
        }));
    };



    const handleUpdate = async () => {
        setUpdateLoading(true);

        try {
            const payload = {
                id: formData.id,
                name: formData.name,
                url: formData.url,
                serverRole: formData.serverRole,
                serverType: formData.serverType,
                priority: formData.priority,
                serverPassword: formData.serverPassword,
                serverUserName: formData.serverUserName,
                isActive: formData.isActive,
                vendorId,
            };

            const response = await put(
                `${API_URL}/api/vendor-application-servers/${formData.id}`,
                payload
            );

            if(response && response?.statusCode===200) {
                showSnackbar(
                    response?.message || "Application Server Updated Successfully",
                    "success"
                );
                onClose();
            } else {
                showSnackbar(
                    response?.message || "Error While Creating.",
                    "error"
                );
            }
            
        } catch (error: any) {
            //console.log('error',error)
            showSnackbar(
                error?.response?.data?.message || "Failed to save Application Server",
                "error"
            );
        }finally {
            setUpdateLoading(false);
        }
    };
    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
        >
            <DialogTitle>
                Update Application Server
            </DialogTitle>

            <DialogContent>
                <Grid container spacing={2} mt={1}>

                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label="Server Name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label="Server URL"
                            name="url"
                            value={formData.url}
                            onChange={handleChange}
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <TextField
                            select
                            fullWidth
                            label="serverType"
                            name="serverType"
                            value={formData.serverType}
                            onChange={handleChange}
                            >
                            {TYPE_OPTIONS.map((type) => (
                                <MenuItem key={type.value} value={type.value}>
                                {type.label}
                                </MenuItem>
                            ))}
                        </TextField>
                        {/* <TextField
                            fullWidth
                            label="Server Type"
                            name="serverType"
                            value={formData.serverType}
                            onChange={handleChange}
                        /> */}
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <TextField
                            select
                            fullWidth
                            label="Server Role"
                            name="serverRole"
                            value={formData.serverRole}
                            onChange={handleChange}
                        >
                            <MenuItem value="MAIN">
                                MAIN
                            </MenuItem>
                            <MenuItem value="BACKUP">
                                BACKUP
                            </MenuItem>
                        </TextField>
                    </Grid>

                    {/* <Grid item xs={12} md={6}>
                        <TextField
                            select
                            fullWidth
                            label="Health Status"
                            name="healthStatus"
                            value={formData.healthStatus}
                            onChange={handleChange}
                        >
                            <MenuItem value="UP">
                                UP
                            </MenuItem>
                            <MenuItem value="DOWN">
                                DOWN
                            </MenuItem>
                        </TextField>
                    </Grid> */}

                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            type="number"
                            label="Priority"
                            name="priority"
                            value={formData.priority}
                            onChange={handleChange}
                        />
                    </Grid>

                    {/* <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            type="number"
                            label="Failure Count"
                            name="failureCount"
                            value={formData.failureCount}
                            onChange={handleChange}
                        />
                    </Grid> */}

                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label="Server Username"
                            name="serverUserName"
                            value={formData.serverUserName}
                            onChange={handleChange}
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            type="password"
                            label="Server Password"
                            name="serverPassword"
                            value={formData.serverPassword}
                            onChange={handleChange}
                        />
                    </Grid>

                    <Grid item xs={12} md={3}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={formData.isActive}
                                    onChange={(e) =>
                                        setFormData({
                                            ...formData,
                                            isActive:
                                                e.target.checked,
                                        })
                                    }
                                />
                            }
                            label="Active"
                        />
                    </Grid>

                    {/* <Grid item xs={12} md={3}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={
                                        formData.autoFailover
                                    }
                                    onChange={(e) =>
                                        setFormData({
                                            ...formData,
                                            autoFailover:
                                                e.target.checked,
                                        })
                                    }
                                />
                            }
                            label="Auto Failover"
                        />
                    </Grid> */}

                </Grid>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}>
                    Cancel
                </Button>

                <Button
                    variant="contained"
                    onClick={handleUpdate}
                    disabled={updateLoading}
                >
                    {updateLoading ? "Updating..." : "Update"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default UpdateApplicationServer;